/**
 * Tooltip directive for Edit functionality
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.
  directive('lmTooltip', ['$templateCache', '$compile', '$timeout', '$window',
    function ($templateCache, $compile, $timeout, $window) {
      return {
        restrict: 'A',
        replace: false,
        scope: true,
        link: function (scope, element, attrs) {
          scope._tooltip_element_ = element;
          scope.event = {};

          var setTooltipCss = function () {
            var bottom = $window.innerHeight - scope.event.clientY + 10;

            if (bottom + scope._tooltip_.outerHeight() > $window.outerHeight) {
              delete scope.tooltipCSS.bottom;
              scope.tooltipCSS.top = 0;
            } else {
              delete scope.tooltipCSS.top;
              scope.tooltipCSS.bottom = (bottom < 0) ? 10 : bottom;
            }

            if (scope.event.pageX + scope._tooltip_.outerWidth() > $window.document.body.offsetWidth) {
              delete scope.tooltipCSS.left;
              scope.tooltipCSS.right = 10;
            } else {
              var left = scope.event.clientX - scope._tooltip_.outerWidth() / 2;
              delete scope.tooltipCSS.right;
              scope.tooltipCSS.left = (left < 0) ? 10 : left;
            }

            if (scope.eventInProgress) scope.eventInProgress = false;
          };

          scope.getEvent = function (event) {
            if (scope.eventInProgress) return;
            scope.event = event;

            scope.eventInProgress = true;

            $timeout(setTooltipCss, 50);
          };

          if (attrs.lmTooltip.indexOf('.html') !== -1) {
            scope.tooltipContent = $templateCache.get(attrs.lmTooltip);
          } else {
            scope.watcher = attrs.$observe('lmTooltip', function (value) {
              $timeout(function () {
                scope.tooltipContent = value;
                if (scope._tooltip_) {
                  scope._tooltip_.html(scope.tooltipContent);
                }
              });
            });
          }

          scope.tooltipCSS = {};

          var showTooltip = function (event) {
            scope.event = event;

            if (!attrs.lmTooltip) return;

            angular.element(document).bind('mousemove', scope.getEvent);

            scope.tooltipCSS = {};

            scope._tooltip_ = $templateCache.get('lm-tooltip/tooltip.tpl.html');
            scope._tooltip_ = $compile(scope._tooltip_)(scope);
            scope._tooltip_.html(scope.tooltipContent);
            $compile(scope._tooltip_.contents())(scope.$parent);

            angular.element('body').append(scope._tooltip_);
            setTooltipCss();

            $timeout(function (event) {
              scope.tooltipCSS.bottom -= 20;
              scope.tooltipCSS.display = 'block';
              TweenMax.to(scope._tooltip_, 0.35, {
                opacity: 1,
                ease: Expo.easeInOut
              });
            }, 50);
          };

          var hideTooltip = function () {
            angular.element(document).unbind('mousemove', scope.getEvent);
            if (!scope._tooltip_) return;

            scope.tooltipCSS.display = 'none';
            scope._tooltip_.remove();
          };

          scope._tooltip_element_.bind('mouseenter', showTooltip);

          scope._tooltip_element_.bind('mouseleave', hideTooltip);

          scope._tooltip_element_.on('$destroy', function () {
            if (scope.watcher) scope.watcher();
            scope._tooltip_element_.unbind('mouseenter', showTooltip);
            scope._tooltip_element_.unbind('mouseleave', hideTooltip);
            if (scope._tooltip_) scope._tooltip_.remove();

            scope.$destroy();
          });
        }
      };
    }]);
